import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { CandlestickTileConfigState } from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';
import { CandlestickTileContent } from 'widgets/candlestickTile/components/CandlestickTileContent';
import { useWidgetContext } from 'widgets/WidgetContext';
import { buildCandlestickTileData } from 'widgets/candlestickTile/candlestickTileData';
import { priceStreamedDataSelectors } from 'widgets/candlestickTile/store/stream/streamSlice';
import { useExternalMarketBarData } from 'marketData/hooks';

const { useSymbolStreamedData } = priceStreamedDataSelectors;

export function CandlestickTileMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol, symbology } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<CandlestickTileConfigState>();
    const { widgetKey } = useWidgetContext();

    const { bucketSize, showDataFor } = config;

    const externalMarketData = useExternalMarketBarData(
        symbol,
        symbology,
        config.bucketSize
    );
    const streamData = useSymbolStreamedData(symbol, config);
    const data = buildCandlestickTileData(
        bucketSize,
        streamData,
        externalMarketData,
        showDataFor
    );

    return (
        <CandlestickTileContent
            data={data}
            config={config}
            dispatchConfigChanged={dispatchConfigChanged}
            symbol={symbol}
            capsuleKey={`${widgetKey}=${symbol}`}
        />
    );
}
